import ptBR from './locales/pt_BR.json'

export default {
  'pt-BR': {
    translation: ptBR
  }
}
